const statisticsCz = {
    "user_statistics": "Statistiky uživatelů",
    "menu_item_clicks": "Kliknutí na položky nabídky",
    "statistics": "Statistika",
    "user_traffic": "Uživatelská návštěvnost",
    "last_7_days": "Posledních 7 dní",
    "last_30_days": "Posledních 30 dní",
    "menu_item": "Položka nabídky",
    "click_count": "Počet kliknutí",
    "error_fetching_user_statistics": "Chyba při načítání statistik uživatelů.",
    "error_fetching_menu_item_statistics": "Chyba při načítání statistik položek nabídky.",
    "statistics_feature_not_available": "Funkce statistik je k dispozici pouze v tarifu PRO. Pro přístup k této funkci si prosím upgradujte předplatné.",
    "change_subscription_plan": "Změnit předplatné",
    "permission_denied": "Oprávnění zamítnuto",
    "error_fetching_rating_statistics": "Chyba při načítání statistik hodnocení.",
    "menu_item_ratings": "Hodnocení položek v nabídce",
    "likes": "lajky",
    "dislikes": "nelíbí se",
    "rating_trends_last_7_days": "Trendy hodnocení (posledních 7 dní)",
    "rating_trends_last_30_days": "Trendy hodnocení (za posledních 30 dní)",
    "kpi_total_visitors": "Celkem návštěvníků",
    "kpi_avg_per_day": "Průměr / den",
    "kpi_peak_day": "Špičkový den",
    "kpi_top_item": "Nejkliknutější položka",
    "kpi_clicks": "kliknutí",
    "kpi_vs_prev": "vs předchozí období",
    "current_period": "Aktuální období",
    "previous_period": "Předchozí období",
    "visitors": "návštěvníků",
    "hourly_traffic": "Hodinová návštěvnost",
    "utm_sources": "Zdroje návštěvnosti",
    "utm_unknown": "Neznámý",
    "no_data": "Žádná data",
};

export default statisticsCz;
